import { useEffect, useRef, useState } from 'react'
import { useAuth } from '@/context/AuthContext'
import { useTeamContext } from '@/context/TeamContext'
import { identifyFeedbaskUser, unidentifyFeedbaskUser } from '@/utils/feedbask'

export function FeedbaskIdentificationManager() {
	const { user, session, isInitialized: authInitialized } = useAuth()
	const {
		teamData,
		isInitialized: teamInitialized,
		isLoading: teamLoading,
	} = useTeamContext()
	const [hasTimedOut, setHasTimedOut] = useState(false)
	const timeoutRef = useRef<NodeJS.Timeout>()
	const lastIdentifiedDataRef = useRef<string>()

	useEffect(() => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
		}

		if (!session || !user || !authInitialized) {
			unidentifyFeedbaskUser()
			setHasTimedOut(false)
			lastIdentifiedDataRef.current = undefined
			return
		}

		if (teamInitialized) {
			const teamInfo = teamData
				? {
						name: teamData.name,
						plan_id: teamData.plan_id,
						created_at: teamData.created_at,
				  }
				: undefined

			const dataKey = JSON.stringify({
				userId: user.id,
				teamId: teamData?.id || null,
				planId: teamData?.plan_id || null,
			})

			if (lastIdentifiedDataRef.current !== dataKey) {
				identifyFeedbaskUser(user, teamInfo)
				lastIdentifiedDataRef.current = dataKey
				setHasTimedOut(false)
			}
			return
		}

		if (!hasTimedOut && teamLoading) {
			timeoutRef.current = setTimeout(() => {
				const dataKey = JSON.stringify({
					userId: user.id,
					teamId: null,
					planId: null,
				})

				if (lastIdentifiedDataRef.current !== dataKey) {
					identifyFeedbaskUser(user, undefined)
					lastIdentifiedDataRef.current = dataKey
				}
				setHasTimedOut(true)
			}, 3000)
		}

		if (!teamInitialized && !teamLoading) {
			const dataKey = JSON.stringify({
				userId: user.id,
				teamId: null,
				planId: null,
			})

			if (lastIdentifiedDataRef.current !== dataKey) {
				identifyFeedbaskUser(user, undefined)
				lastIdentifiedDataRef.current = dataKey
			}
		}

		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}
		}
	}, [
		user,
		session,
		authInitialized,
		teamData,
		teamInitialized,
		teamLoading,
		hasTimedOut,
	])

	return null
}
